export const matchAttribute = (variant: GQL.IProductVariant | GQL.IOrderItem, attributes: Array<GQL.IAttribute>) => {
    for (const attribute of attributes) {
        if ((variant.definition || {})[attribute.id] != undefined) {
            return attribute;
        }
    }

    return undefined;
};



// WEBPACK FOOTER //
// ./src/helpers/attributes/matchAttribute.ts